import angular from 'angular';
import modalConfirmation from '../../../shared/components/modal-response/modal-response.view.html';
import modalAtributosValores from '../../products-list/modal-atributos-valores/modal-atributos-valores.view.html';
import modalAtributos from '../../products-list/modal-atributos/modal-atributos.view.html';
import templatefiltersAD from '../../products-list/dynamic-filters/templates/dynamic-filters.view-adaptative.html';

let inject = [
    '$scope',
    'CategoryService',
    '$state',
    '$rootScope',
    'SharedService',
    '$stateParams',
    '$uibModal',
    '$timeout',
    'Pagination',
    'SessionService',
    'CategoryProductsService',
    '$filter',
    '$location',
    '$anchorScroll',
    'ngAuthSettings',
    '$mdBottomSheet',
    '$window'

];

class CategoryController {
    constructor($scope,
                CategoryService,
                $state,
                $rootScope,
                SharedService,
                $stateParams,
                $uibModal,
                $timeout,
                Pagination,
                SessionService,
                CategoryProductsService,
                $filter,
                $location,
                $anchorScroll,
                ngAuthSettings,
                $mdBottomSheet,$window) {
        this.$state = $state;
        this.$scope = $scope;
        this.$mdBottomSheet = $mdBottomSheet;
        this.ngAuthSettings = ngAuthSettings;
        this.Pagination = Pagination;
        this.SessionService = SessionService;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.$anchorScroll = $anchorScroll;
        this.$uibModal = $uibModal;
        this.CategoryService = CategoryService;
        this.$timeout = $timeout;
        this.$window = $window;
        this.SharedService = SharedService;
        this.CategoryProductsService = CategoryProductsService;
        this.$filter = $filter;
        this.loanding = false;
        this.pagerCategories = [];
        this.itemsPerPage = 12;
        this.loadingCategories = true;
        this.categoryId = this.$stateParams.idCategory || '';
        this.categorySlug = this.$stateParams.categorySlug || '';
        this.productSale = this.$stateParams.productSale || '';
        this.productsList = [];
        this.productHighPriceTest = 0;
        this.productLowPriceTest = 0;
        this.categoryAttributes = [];
        this.hasMoreAttributes = false;
        this.categoryProductAttributes = [];
        this.categoryAttributesGroups = [];
        this.filterAttributesProducts = {};
        this.nombreAtributo = {};
        this.propAtributo = {};

        this.pageSize = 12;
        this.currentPage = 1;
        this.totalItems = 1;

        this.controlPrice = 0;
        this.sortType = 1;
        this.filterSaved = null;
        this.searchText = '';
        this.typeview = 1;
        this.dataFilter = {};
        this.localFilters = null;
        this.slugPromition = '';
        this.view = 50;


        this.ctrlTest = 3;
        this.initializeTest = false;

        this.customFilters = {
            productHighPrice: null,
            productLowPrice: null,
            productHighPriceTest: null,
            productLowPriceTest: null
        };

        this.status = false;
        this.sortReverse = false;

        this.slider = {
            minValue: 10,
            maxValue: 90,
            options: {
                floor: 0,
                ceil: 100,
                step: 1
            }
        };
        this.$rootScope.$on('onChangeCompany', (event, arg) => {
          event.stopPropagation();
          this.SharedService.getCMSBanners(this.pageName, __env.adaptative ? 1:0,arg).then(response => {
            this.cmsData = response;
          });
        });
    }

    $onInit() {
        this.SharedService.getCMSBanners(this.pageName, __env.adaptative ? 1:0).then(response => {
            this.cmsData = response;
            this.shCtrl.setTags(this.cmsData.seo);
        });

        if (__env.adaptative) {
            this.filterBarSticky();
            this.searchBreadcumb = decodeURIComponent(this.$stateParams.searchText);
        }

        this.dataFilter = this.CategoryProductsService.getFiltersData();

        if (this.$stateParams.idCategory || this.$stateParams.categorySlug) {
            this.getProducts(false, false, false, false, false);
            if (this.dataFilter) {
                if (this.$stateParams.categorySlug === this.dataFilter.slug || this.$stateParams.idCategory === this.dataFilter.id) {
                    this.pageSize = this.dataFilter.pageSize;
                    if (this.dataFilter.pageNumber) {
                        this.currentPage = this.dataFilter.pageNumber;
                    } else {
                        this.currentPage = 1;
                    }
                    this.searchText = this.dataFilter.internSearchText;

                    this.customFilters.attributes = this.dataFilter.filters.attributes;
                    this.customFilters.productHighPriceTest = this.dataFilter.filters.productHighPrice;
                    this.customFilters.productLowPriceTest = this.dataFilter.filters.productLowPrice;
                    this.sortType = this.dataFilter.filters.sort;
                    this.getCurrentCategory();
                } else {
                    this.CategoryProductsService.setFiltersData(null);
                    this.getCurrentCategory();
                }
            } else {
                this.getCurrentCategory();
            }
        } else if (this.$stateParams.searchText) {
            if (this.dataFilter) {
                if (this.$stateParams.searchText === this.dataFilter.searchText) {
                    this.pageSize = this.dataFilter.pageSize;
                    if (this.dataFilter.pageNumber) {
                        this.currentPage = this.dataFilter.pageNumber;
                    } else {
                        this.currentPage = 1;
                    }
                    this.searchText = this.dataFilter.internSearchText;
                    this.customFilters.attributes = this.dataFilter.filters.attributes;
                    this.customFilters.productHighPriceTest = this.dataFilter.filters.productHighPrice;
                    this.customFilters.productLowPriceTest = this.dataFilter.filters.productLowPrice;
                    this.sortType = this.dataFilter.filters.sort;
                    this.getProducts(false, false, false, false, false);
                } else {
                    this.CategoryProductsService.setFiltersData(null);
                    this.getProducts(false, false, false, false, false);
                }
            } else {
                this.getProducts(false, false, false, false, false);
            }
        } else if (this.$stateParams.slug) {
            this.slugPromition = this.$stateParams.slug;
            this.getProducts(false, false, false, false, false);
        }

    }

    $onDestroy() {
        this.cleanFilters();
    }

    showFilter(value) {
        this.filter = value;
    }

    showSort(value) {
        this.sort = value;
    }

    changeView(value) {
        this.view = value;
    }

    Atributos(categoryId) {
        this.CategoryProductsService.getAtributos(categoryId).then(response => {

            let options = {
                title: this.currentCategory.title,
                isHtml: false,
                content: response,
                size: 'md',
                //showBottonCancel : false,
                textActionCancel: '',
                textAction: 'Aceptar',
            };
            this.atributosResponse(options);

        }).catch(reason => {

        });
    }

    atributosResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalAtributos,
            controller: 'modalAtributos',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });

        modalInstance.result.then((respuesta) => {
            this.AtributosValores(respuesta, this.categoryId);
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });

    }

    AtributosValores(attribute, categoryId) {
        this.CategoryProductsService.getValoresAtributos(categoryId, attribute.id).then(response => {

            if (!this.customFilters.attributes) {
                this.customFilters.attributes = [];
            }
            let atributosFiltros = this.customFilters.attributes[attribute.id];
            let options = {
                //title : attribute.title,
                titulo: attribute.title,
                isHtml: false,
                //content : response,
                atributos: response.data,
                size: 'md',
                //showBottonCancel : false,
                textActionCancel: '',
                textAction: 'Aceptar',
                atributoId: attribute.id,
                attributesFilters: atributosFiltros ? this.customFilters.attributes : {[attribute.id]: []},
                attribute: attribute,
            };
            //if(this.categoryProductAttributes[group].indexOf(value) !== -1) {
            this.atributosValoresResponse(options);

        }).catch(reason => {
            /*this.loadingProducts = false;
            this.localFilters = angular.copy(this.customFilters.attributes);*/
        });
    }

    atributosValoresResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalAtributosValores,
            controller: 'modalAtributosValores',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });

        modalInstance.result.then((resultado) => {

            let vm = this;

            angular.forEach(resultado, function (value, key) {
                vm.updateProductAttribute(value.group, value.value, value.addRemove, value.att, value.val, value.title,false);
                vm.getProducts();
            });
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    confirmTimerTest() {
        this.$timeout(() => {
            this.timerTest();
        }, 1000);
    }

    timerTest() {
        if (this.ctrlTest > 0) {
            this.ctrlTest--;
            this.confirmTimerTest();
        }
        else {
            this.getProducts();
            this.initializeTest = false;
        }
    }

    onChangePriceFilter() {
        if (this.initializeTest) this.ctrlTest = 3;
        else {
            this.initializeTest = true;
            this.timerTest();
        }
    };

    /**
     Get current category
     @method getCurrentCategory
     */
    getCurrentCategory() {
        this.CategoryService.getCurrentCategory(this.$stateParams.idCategory, this.$stateParams.categorySlug).then(response => {
            this.currentCategory = response;
          this.shCtrl.setTags(this.currentCategory.seo);
            if (!this.categoryId) {
                this.categoryId = response.id;
                this.$rootScope.$emit('onChangeCompany',response.company);
                this.company=response.company;
            }
            this.CategoryService.getPostByCategory(this.company).then(responsePostByCategory => {
              this.postByCategory = responsePostByCategory.posts;
            });
            this.getAttributesCategory(this.$stateParams.idCategory, this.$stateParams.categorySlug);
        }).catch(reason => {
            this.$state.go('404');
        });

    }

    getAttributesCategory(idCategory, categorySlug) {
        this.CategoryService.getAttributesCategory(idCategory, categorySlug).then(response => {
            this.categoryAttributes = response.data;
            this.categoryAttributesO = angular.copy(this.categoryAttributes);
            this.hasMoreAttributes = response.hasMoreAttributes;
        }).catch(reason => {
            this.$state.go('404');
        });
    };

    cleanProductsList() {
        var i = 0;
        while( ( i = this.productsList.shift()) !== undefined ) {
            // console.log(i);
        }
    }

    getProducts(footer, cleanFilter, footerPlace, intern, scrollToTop = true) {
        // this.productsList=[];
        if (this.loadingProducts) return;
        let searchText = this.$stateParams.searchText;
        //this.controlPrice = this.searchText ? 0 : this.controlPrice;
        this.searchText = (cleanFilter && !intern ? '' : this.searchText);
        if (!searchText) searchText = '';
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }



        let data = {
            id: this.$stateParams.searchText ? null :this.categoryId,
            slug: this.$stateParams.searchText ? null :this.categorySlug,
            pageSize: this.pageSize,
            searchText: decodeURIComponent(searchText),
            internSearchText: this.searchText,
            userId: userId,
            slugPromition: this.$stateParams.searchText ? null :this.slugPromition,
            filters: {
                pageNumber: this.currentPage,
                attributes: (cleanFilter ? null : this.customFilters.attributes),
                productHighPrice: (cleanFilter ? 0 : this.customFilters.productHighPriceTest),
                productLowPrice: (cleanFilter ? 0 : this.customFilters.productLowPriceTest),
                sort: this.sortType
            }
        };

        if (!angular.equals(this.filterSaved, data)) {
            this.filterSaved = data;
        } else {
            return;
        }
        this.loadingProducts = true;


        this.CategoryProductsService.getProducts(data, this.$stateParams.productSale).then(response => {


            // this.pageSize = (this.pageSize > response.cantidadTotal ? 24 : this.pageSize);
            this.totalItems = angular.copy(response.cantidadTotal);
            this.totalPages = angular.copy(response.totalPage);

            if (response.items.length) {
                //there is data on the back page?

              //
              //
              var Products = [];

              response.items.forEach((valFor, indexFor) => {

                Products.push(
                    {
                        "item_id": valFor.id,
                        "item_name": valFor.name,
                        "price": valFor.currentPrice,
                    }

                );
              });


              this.$window.dataLayer.push({
                "event": "view_item_list",
                "ecommerce": {
                  "impressions": Products
                }
              });


              //
              //
                if (this.dataFilter && ((this.categorySlug && this.categorySlug === this.dataFilter.slug) || (searchText && decodeURIComponent(searchText) === this.dataFilter.searchText))) {
                    if (this.dataFilter.pageNumber) {
                        this.currentPage = this.dataFilter.pageNumber;
                    } else {
                        this.currentPage = 1;
                    }
                    if (!this.controlPrice) {
                        this.customFilters.productHighPriceTest = this.dataFilter.filters.productHighPrice;
                        this.customFilters.productLowPriceTest = this.dataFilter.filters.productLowPrice;
                        this.controlPrice++;
                    }
                } else {
                    if (!this.controlPrice) {
                        this.customFilters.productHighPriceTest = response.highestPrice;
                        this.customFilters.productLowPriceTest = 0;
                        this.controlPrice++;
                    }
                }

                /* Si se esta realizando una busqueda general se muestra el logo de las dos marcas */
                if(searchText != ''){
                    this.$rootScope.$emit('onChangeCompany');
                }

                this.customFilters.productHighPrice = response.highestPrice;
                this.customFilters.productLowPrice = response.lowestPrice;
                this.dataFilter = {};
                this.cleanProductsList();
                this.productsList = angular.copy(response.items);
                this.loadingProducts = false;
                this.localFilters = angular.copy(this.customFilters.attributes);
                this.activateProducts(this.customFilters);
                let resultView = this.SessionService.get('itemsView');
                if (!__env.adaptative) {
                    if (!resultView) {
                        if ($(window).width() >= 1200) {
                            this.setCookieItemsView(this.shCtrl.globalParams.itemsView.pc,scrollToTop);
                        } else if ($(window).width() < 1200) {
                            this.setCookieItemsView(this.shCtrl.globalParams.itemsView.tablet,scrollToTop);
                        }
                    } else {
                        this.setCookieItemsView(resultView,scrollToTop);
                    }
                }

            } else {
                if (searchText && !this.searchText) {
                    this.$state.go('home.productNotFound', {productSearchText: searchText});
                } else {
                    this.productsList = [];
                    this.loadingProducts = false;
                    this.controlPrice = 1;
                }
            }
            //this.shCtrl.scrollToTop(1);
        }).catch(reason => {
            this.loadingProducts = false;
            this.localFilters = angular.copy(this.customFilters.attributes);
        });

    }

    activateProducts(item) {
        this.sliderOptions = {
            options: {
                showSelectionBar: true,
                selectionBarGradient: {
                    from: this.ngAuthSettings.site.info.style.secondColor,
                    to: this.ngAuthSettings.site.info.style.secondColor
                },
                getPointerColor: (value) => {
                    return this.ngAuthSettings.site.info.style.mainColor;
                },
                floor: 0,
                step: 1,
                minRange: 10,
                ceil: item.productHighPrice,
                noSwitching: true,
                onEnd: (sliderId, modelValue, highValue) => {
                    this.getProducts();
                },
                translate: (value) => {
                    return (this.$filter('currency')(value, '$', 0));
                }
            }
        };
        this.$timeout(() => {
            this.$scope.$broadcast('rzSliderForceRender');
        }, 1000);
    };



    updateProductAttribute(group, value, addRemove, att, val, title, recargar = true) {

        this.propAtributo[val] = {"group": group, "nombre": value, "atributoId": att, 'title': title};
        if (!this.categoryProductAttributes[group]) {
            this.categoryAttributesGroups.push(group);
            this.categoryProductAttributes[group] = [];
        }
        if (this.categoryAttributesGroups.indexOf(group) < 0) {
            this.categoryAttributesGroups.push(group);
        }

        if (!this.filterAttributesProducts.hasOwnProperty(att)) {
            this.filterAttributesProducts[att] = [];
        }

        if (addRemove) {
            if (this.categoryProductAttributes[group].indexOf(value) !== -1) {
                // ya existe
                return;
            } else {
                this.categoryProductAttributes[group].push(value);
                this.filterAttributesProducts[att].push(val);

            }
        }
        else {
            let indexOf = this.categoryProductAttributes[group].indexOf(value);
            if (indexOf >= 0) {
                this.categoryProductAttributes[group].splice(indexOf, 1);
            }

            let indexOfFilter = this.filterAttributesProducts[att].indexOf(val);
            if (indexOfFilter >= 0) {
                this.filterAttributesProducts[att].splice(indexOfFilter, 1);
            }
            if (!this.filterAttributesProducts[att].length) {
                this.categoryAttributesGroups.splice(group, 1);
            }

            let data = this.categoryAttributes.find(val => val.group === group).data;
            data.find(value => value.id === val.toString()).isChecked = false;
        }

        this.customFilters.attributes = angular.copy(this.filterAttributesProducts);
        if (recargar) {
            this.getProducts(false, false, false, false, false);
        }
    }

    changeInternalWordSearch() {
        this.controlPrice = 0;
    }

    compareProductsSelected() {
        let keys = Object.keys(this.productsToCompare.items);
        this.$state.go('/products/compare/' + this.categoryId + '/' + keys.join('-'));
    }

    cleanFilters() {
        if (this.customFilters.attributes) {
            let keyAttributes = Object.values(this.customFilters.attributes);
            if (keyAttributes.length) {
                this.loadInitialAttributesFitler();
            } else {
                this.customFilters.attributes = {};
            }
        } else {
            this.customFilters.attributes = {};
        }
        this.controlPrice = 0;
        this.getProducts(false, true);
    }

    loadInitialAttributesFitler() {
        this.customFilters.attributes = {};
        this.getAttributesCategory(this.$stateParams.idCategory, this.$stateParams.categorySlug);
        this.categoryProductAttributes = [];
        this.categoryAttributesGroups = [];
        this.filterAttributesProducts = {};
        this.propAtributo = {};
        this.controlPrice = 0;
        this.filterSaved = null;
        this.searchText = '';
        this.dataFilter = {};
        this.searchTextAttributes = '';
        this.customFilters = {
            productHighPrice: null,
            productLowPrice: null,
            productHighPriceTest: null,
            productLowPriceTest: null
        };
    }

    setPagination(type, footer) {
        this.pageSize = type;
        this.currentPage = 1;
        this.getProducts(footer);
    }

    setSort(type, footer) {
        this.sortType = type;
        this.sortReverse = !(type === 2 || type === 4 || type === 1);
        this.getProducts(footer);
    }

    getSelectedText() {
        if ($scope.sortType !== undefined) {
            return "You have selected: Item " + $scope.sortType;
        } else {
            return "Please select an item";
        }
    }

    filterBarSticky() {
        const filterBar = document.querySelector('#filterBar');
        const sticky = filterBar.offsetTop;

        function stickyFilter() {
            if (window.scrollY >= sticky) {
                filterBar.classList.add("sticky");
            } else {
                filterBar.classList.remove("sticky");
            }
        }

        window.addEventListener('scroll', stickyFilter);
    }

    setSortOrder() {
        if (this.sortType === 2 || this.sortType === 3) {

            if (!this.sortReverse) {
                this.setSort(2);
            } else {
                this.setSort(3);
            }

        } else if (this.sortType === 4 || this.sortType === 5) {
            if (!this.sortReverse) {
                this.setSort(4);
            } else {
                this.setSort(5);
            }
        }
    }

    setCookieItemsView(itemView, scrollToTop = true) {
        itemView = parseInt(itemView);
        this.typeview = itemView;
        this.SessionService.put('itemsView', itemView);

        if (scrollToTop) {
            var elmnt = document.getElementById("top");
            elmnt.scrollIntoView();


        }
    };

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }
}

CategoryController.$inject = inject;

export default CategoryController;




// WEBPACK FOOTER //
// ./www/components/catalog/category/category-products/category-products.controller.js